$(document).ready(function() {
		
	// GLOBAL CODE: For Every Page
	var includeFreeBeardOil = false;
	setupGruffBars(includeFreeBeardOil);
	intervalChanges();
	setInterval(intervalChanges, 1500);
	document.body.classList.add(/Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop');
	
	
	$('body').on('click', '.add_to_cart, .js-change-quantity', function() {
		console.log('triggered click on ', $(this));
		setTimeout(function() { setupGruffBars(includeFreeBeardOil); }, 700);
	});
	
	var checkForElement = setInterval(function() {
		if ($('.collection.gp .column.thumbnail').length > 0) {
			clearInterval(checkForElement);
			collectionSwatchHandler();
		}
	}, 1500);

	
	
	if (typeof activeSection !== 'undefined') {
		$("#header a").filter(function() {
			return $(this).text().includes(activeSection);
		}).addClass('active');
	}

		
	// COLLECTION-SPECIFIC CODE:
	if($('body.collection').length){
		collectionSwatchHandler();
	}

    // HOMEPAGE-SPECIFIC CODE:
    if ($('body.index').length) {
        if ($('body.desktop .lightningRowWrapper .lp > img').length) {
            setTimeout(function() {
                let minHeightLP = parseFloat($('body.desktop .lightningRowWrapper .lp > img').closest('.col-12').next().height()) - 25;
                $('body.desktop .lightningRowWrapper .lp > img').css('min-height', minHeightLP + 'px');
            }, 900);
        }
    }
		
	//PRODUCT-SPECIFIC CODE: For Product Pages Only
	if($('body.product').length){
		movePricingOnProductPage();
		coaleseOptions();
		setupProductButtons();
		addMeasurementsToSizes();
		replaceMorePaymentOptions();
		
		
		productImages = $('.product-main.gp .product_gallery .gallery-cell');
		
		
		
		maxChecks = 150;
		existingChecks = 0;
		var checkExist = setInterval(function() {
			if(existingChecks >= maxChecks){ clearInterval(checkExist); }
			if ($('form.shopify-product-form').length && $('.product_gallery.flickity-enabled').length) {
				clearInterval(checkExist);
				
				
				var displaySelections = getCurrentSelections();
				updateImagesBasedOnSwatches();
				
				var titleHTML = $('.product-block--title').length > 0 ? $('.product-block--title').prop('outerHTML') : '';
				var flavorHTML = $('h3.flavor').length > 0 ? $('h3.flavor').prop('outerHTML') : '';
				var navHTML = $('.gpp-nav').length > 0 ? $('.gpp-nav').prop('outerHTML') : '';
				
				$('<div class="over">' + titleHTML + flavorHTML + navHTML + '</div>')
					.hide()
					.appendTo('.gpp .product_gallery')
					.fadeIn();

				$('.product__details .product-block--title, .gpp .option_title').addClass('mobile_hidden');
				$('.product__details h3.flavor,.product__details .gpp-nav').closest('.product-block').addClass('mobile_hidden');
				setupProductButtons();
				setSwatchClickHandler();
			}
			existingChecks++;
		}, (150 + existingChecks));
	}
	
	
	$(window).on('resize orientationchange', function() {
		if (!pageLoaded) {return;}
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(runAfterResize, 700);
	});
	$(window).on('load', function() {
		pageLoaded = true;
	});
	
	$('.gn a.nls').filter(function() { return $(this).text().trim() === "Beard Oil"; }).html("Beard<span class='is-hidden-mobile-only'> Oil</span>");


	$('#currency-list li button').on('click', function(event) {
		  addClientLocationToBody();
	});
	
	autoUpdateCurrency();

	setCountdowns();

}); // end document.ready

var productImages, imgFilter, swatchNavTimer, gruff_bucks_open, maxChecks, existingChecks, pageLoaded=false, debounceTimer, activeTimeout, gppMediaCarousel, fetchedCountryHandle = 'US', countdownInterval;

var jockIDs = {"S":"40370626789431", "M":"40370628657207","L":"40370628689975","XL":"40370628722743","XXL":"40370628755511"};
var beardOilIDs = {"Leather":"40471550165047", "Sugar Cookie":"40471559176247","Sandalwood":"40471559209015","Mint & Moss":"40471559241783","Classic":"40471559274551"};


function setCountdowns() {
	const now = new Date();
	const isDST = now.getTimezoneOffset() < new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
	const cstOffset = isDST ? -5 : -6;

	const endOfDayCST = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
	endOfDayCST.setHours(23, 59, 59, 999);

	const endOfDayCSTTimestamp = Math.floor(endOfDayCST.getTime() / 1000);

	$('.countdown:not(.set)').each(function () {
		let to;
		if ($(this).data('to') && $(this).data('to') !== '%%adapt%%') {
			to = parseInt($(this).data('to'), 10);
		} else {
			to = endOfDayCSTTimestamp;
			$(this).data('to', to);
		}

		updateDisplay(this, to);
		$(this).addClass('set');
	});

	if (!countdownInterval) {
		countdownInterval = setInterval(updateCountdowns, 1000); // Set interval to update every second
	}
}

function updateDisplay(element, to) {
	const now = Math.floor(Date.now() / 1000);
	const timeLeft = to - now;

	const days = Math.floor(timeLeft / (60 * 60 * 24));
	const hours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60));
	const minutes = Math.floor((timeLeft % (60 * 60)) / 60);
	const seconds = Math.floor(timeLeft % 60);

	let displayString = "";

	if (timeLeft > 0) {
		if (days > 0) {
			displayString += `<div class='days'><b>${days}</b><i>DAYS</i></div>`;
		}
		if (hours > 0) {
			displayString += `<div class='hours'><b>${hours}</b><i>HOURS</i></div>`;
		}
		if (minutes > 0) {
			displayString += `<div class='minutes'><b>${minutes}</b><i>MIN</i></div>`;
		}
		displayString += `<div class='seconds'><b>${seconds}</b><i>SEC</i></div>`;
	} else {
		displayString = "<div class='expired'>Time's Up!</div>";
	}

	$(element).html(displayString);
}

function updateCountdowns() {
	$('.countdown.set').each(function () {
		const to = parseInt($(this).data('to'), 10);
		updateDisplay(this, to);
	});
}


function replaceMorePaymentOptions() {
  setTimeout(function() {
	$('button.shopify-payment-button__more-options').fadeOut(300, function() {
	  $(this).html('<img src="https://cdn.shopify.com/s/files/1/0647/9837/files/additional-payment-options.png?v=1711050452" alt="More Payment Options">');
	  $(this).fadeIn(300);
	});
  }, 2000); 
}


	


function addClientLocationToBody(){
	var currentCurrencyCode = $('.disclosure--currency > button.disclosure__toggle span.currency-code').text().trim();
	
	dbg('addClientLocationToBody(): currentCurrencyCode is ' + currentCurrencyCode);
	
	// Remove previous geo classes
	$('body').removeClass('geo-us geo-international');
	
	// Check if the current currency code is USD
	if (currentCurrencyCode === 'USD') {
		$('body').addClass('geo-us');
	} else {
		$('body').addClass('geo-international');
	}
		
}


function filter_singlets(x,el){
	$(el).addClass('active').siblings().removeClass('active');
	x = x.toLowerCase();
	if(x == 'all'){
		$('.container.content .content-wrapper .column').show();
	}
	else if(x == 'bare back'){
		$('.container.content .column').each(function() {
			if ($(this).find('.swatch-wrapper .bubble:contains("BB")').length > 0) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});
	}
	else { //filtering for full coverage
	$('.container.content .column').each(function() {
		var col = $(this);
		var hasBareBack = true; 

		col.find('.swatch-wrapper').each(function() {
			if ($(this).find('.bubble:contains("BB")').length > 0) {
				// do nothing
			}
		  else{
			hasBareBack = false;
		  }
		});

		if (hasBareBack) {
			col.hide();
		} else {
			col.show();
		}
	});
}
}

function lazy_load_bg_image_to_el(imageUrl, targetElement) {
	console.log('lazy_load_bg_image_to_el() called for ', targetElement);
	var img = new Image();
	$(img).on('load', function() {
		$(targetElement).css('background-image', 'url("' + imageUrl + '")');
		$(targetElement).removeClass('hidden');
	});
	img.src = imageUrl;
}

function collectionSwatchHandler(){
	//console.log('breakpoint 0');
	//preload small thumbs
	$('.collection.gp .swatch-wrapper').each(function(){
		let imgSrc = $(this).attr('data-small');
		let img = new Image();
		img.src = imgSrc;
	});

	var activeTimeout = null;  
  
	var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints;
	if(isTouchDevice){
		$('.collection.gp .collection_swatches a').addClass('inactive').on('click', function(e) {
			if($(this).hasClass('inactive')){ e.preventDefault(); }
			$(this).addClass('active').removeClass('inactive');
			$(this).siblings().addClass('inactive').removeClass('active');
		});
	}
	
	$('.collection.gp .swatch-wrapper').hover(
		function() { // Mouse over
			clearTimeout(activeTimeout); // Clear any previous timeout
			var imgSmall = $(this).attr("data-small");
			var imgLarge = $(this).attr("data-image");
			$(this).closest('.column').find('.gpt-small').html('<img src="' + imgSmall + '"/>').addClass('active');
			$(this).closest('.column').find('.gpt-large').html('<img src="' + imgLarge + '"/>').addClass('active');
		}, 
		function() { // Mouse out
			var column = $(this).closest('.column');
			activeTimeout = setTimeout(function() {
				column.find('.gpt-small').removeClass('active');
				column.find('.gpt-large').removeClass('active');
			}, 600);
		}
	);

}

function intervalChanges(){	
	setOverPriceToProductDetailsPrice();
	updateFreeJocks();
	styleFreeTextInCart();
	stylePrices();
}

function stylePrices() {
	styleSalePrices();
	styleNonSalePrices();
}

function styleSalePrices(){
	$('.price.gp.price--sale:not(.set)').each(function() {
		let difference = $(this).siblings('.sale.savings').find('.money').text().trim();
		let formattedSavings = "" + difference + " Off!";
		formattedSavings = formattedSavings.replace(',00 Off!', ' Off!');
		formattedSavings = formattedSavings.replace('.00 Off!', ' Off!');
		formattedSavings = formattedSavings.replace('.00 kr Off!', ' kr Off!');
		formattedSavings = formattedSavings.replace(',00 kr Off!', ' kr Off!');
		$(this).addClass('set').append('<span class="dollarsOff">' + formattedSavings + '</span>');
	});
}


function styleNonSalePrices(){
	$('span.money:not(.set)').each(function() {
		var text = $(this).text().trim();
		text = text.replace(',00 kr', ' kr');
		text = text.replace('.00 kr', ' kr');
		var betterText = '';
		for (var i = 0; i < text.length; i++) {
			var char = text.charAt(i);
			if (!/[0-9.,]/.test(char)){ betterText += '<i>' + char + '</i>'; }
			else { betterText += char; }
		}
		
		if (text.startsWith('$') && text.includes('.')) {
			betterText = betterText.replace(/(\.\d+)/, '<u>$1</u>');
		} else if (text.startsWith('£') && text.includes('.')) {
			betterText = betterText.replace(/(\.\d+)/, '<u>$1</u>');
		} else if (text.startsWith('€') && (text.includes('.') || text.includes(','))) {
			betterText = betterText.replace(/(\.\d+)/, '<u>$1</u>');
			betterText = betterText.replace(/(\,\d+)/, '<u>$1</u>');
		}
		
		betterText = betterText.replace('<u>,00</u>', '');
		betterText = betterText.replace('<u>.00</u>', '');
		
		$(this).html(betterText);
		$(this).addClass('set');
	});
}



function autoUpdateCurrency(){
	fetchCountryHandle().then(code => {
		fetchedCountryHandle = code;  // Set the global variable once the fetch is complete
		if(fetchedCountryHandle != 'US'){
			$('body').addClass('geo-international geo-' + fetchedCountryHandle).removeClass('geo-us');
			dbg('autoUpdateCurrency(): international customer');
		}else{
			$('body').removeClass('geo-international').addClass('geo-us');
			dbg('autoUpdateCurrency(): domestic customer');
		}
	});
}

function dbg(x){console.log(x);}

async function fetchCountryHandle() {
	
	if(typeof Shopify === 'object' && typeof Shopify.country === 'string'){ 
		console.log('fetchCountryHandle() got country from Shopify Object: ', Shopify.country)
		return Shopify.country;
	}
	
	try {
		const response = await fetch(
			window.Shopify.routes.root +
			'browsing_context_suggestions.json' +
			'?country[enabled]=true' +
			`&country[exclude]=${window.Shopify.country}` +
			'&language[enabled]=true' +
			`&language[exclude]=${window.Shopify.language}`
		);

		const data = await response.json();
		const countryHandle = data.detected_values.country && data.detected_values.country.handle ? 
							  data.detected_values.country.handle.toUpperCase() : 
							  'US'; 
		console.log('fetchCountryHandle() data: ', data);
		
		return countryHandle;
	} catch (error) {
		return 'US';
	}
}

function styleFreeTextInCart(){
	$('.gn ul.cart_items li *:not(:has(>*))').each(function() {
		if(!$(this).hasClass('free')){
			$(this).html($(this).html().replace('Free', '<span class="free">Free</span>'));
		}
	});
}

function setOverPriceToProductDetailsPrice(){
	$('.over .product-block--price').html($('.product__details .product-block--price').html());
}

function updateFreeJocks(){
	for (var size in jockIDs) {
		if (jockIDs.hasOwnProperty(size)) {
			let field = $('.gn ul.cart_items li[data-variant-id="'+jockIDs[size]+'"]');
			field.addClass('freeJock');
			field.find('.product-quantity-box').hide();
			let amt = field.find('.product-quantity-box input').val();
			if(amt > 1){
				let fieldTitle = field.find('.mini-cart__item-title a').html();
				field.find('.mini-cart__item-title a:not(.set)').addClass('set').html((amt + ' ' + fieldTitle).replace('Jockstrap','Jockstraps'));
			 }
			
		}
	}
}

function runAfterResize() {
	// resize swatches
	$('.swatch.Color .swatch-wrapper').removeClass('xxl xl large small').addClass('xl');
	checkSwatchSizesAndAdjust();
	
}


function checkSwatchSizesAndAdjust() {
	if (!$('.swatch.Color .swatch-wrapper').length) { return; }

	setTimeout(function() {
		let swatchSizes = ['xxl', 'xl', 'large', 'small'];

		let currentSwatchSize = swatchSizes.find(size => $('.swatch.Color .swatch-wrapper').hasClass(size));

		if (currentSwatchSize === 'small') { return; }

		var containerHeight = $('.swatch.Color').height();
		var childHeight = $('.swatch.Color').children('.swatch-element.gp').height();

		if (containerHeight > childHeight * 2) {
			// Change size to the next in the array
			let currentIndex = swatchSizes.indexOf(currentSwatchSize);
			let nextSize = swatchSizes[currentIndex + 1];

			$('.swatch.Color .swatch-wrapper').removeClass(currentSwatchSize).addClass(nextSize);

			// Recursively call function again, but with a delay to allow rendering
			setTimeout(checkSwatchSizesAndAdjust, 0); // Adjust delay as needed
		}
	}, 100); // Adjust this delay as needed
}



function addMeasurementsToSizes(){
	if($('#itemSizing').length){
		$('#itemSizing .bottom').each(function(){
			var size = $(this).siblings('.top').text().trim();
			var measurement = $(this).text().trim().replace(" - ", "-").replace(" in","in").replace(" In","in").replace(" IN","in");
			$('.swatch.Size label').each(function(){
				var labelSize = $(this).text().trim();
				if(size == labelSize){
					$(this).append('<span class="bottom">'+measurement+'</span>');
				}
			});
		});
	}
}

function trim(str){
	return str.trim();
}

function getCurrentSelections(){
	var selections = [];
	var filterSelections = [];
	$('.swatch_options input:checked+.swatch-element').each(function() { 
		selections.push($(this).attr('data-value'));
		if(!$(this).closest('.swatch').hasClass('Size')){
			filterSelections.push($(this).attr('data-value'));
		}
	});	
	var displaySelections = selections.join(' / ');
	imgFilter = trim(filterSelections.join('-').toLowerCase());
	//console.log('displaySelections ' + displaySelections + ' and imgFilter = ' + imgFilter);
	return displaySelections;
}

function updateImagesBasedOnSwatches(){
	$('.product_gallery .gallery-cell').each(function(){
		var dataFilter = trim($(this).attr('data-filter').toLowerCase());
		//console.log(" > " + dataFilter + ' - ' + imgFilter);
		if(imgFilter !== dataFilter && dataFilter !== ''){
			gppMediaCarousel.flickity('remove', this);
		}
	});
	productImages.each(function(){
		var image = $(this);
		var dataFilter = image.attr('data-filter').toLowerCase();
		if(imgFilter === dataFilter || imgFilter == ''){
			if($('.product_gallery').find(image).length === 0){
				gppMediaCarousel.flickity('append', image);
			}
		}
	});
	setTimeout(function() {
		gppMediaCarousel.flickity('select', 0);
	}, 100);
}

function removeEmojis(str){
	return str.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
}



function setSwatchClickHandler(){
	// Update Product Images on Page Load:
	
	$('.swatch_options input').off('change.swatchChange');
	
	// Set click handler
	$('.swatch_options input').on('change.swatchChange', function() {
		
		var displaySelections = getCurrentSelections();		
		$('.option_title.gp,.over h3.flavor').text(displaySelections);
		if(!$(this).closest('.swatch').hasClass('Size')){
			updateImagesBasedOnSwatches()
		}
		
		var interval = setInterval(function() {
			$('.over .product-block--price').html($('.product__details .product-block--price').html());
		}, 100);
		setTimeout(function() { clearInterval(interval); }, 700);

		
		if($(window).width() < 500){
			$('.gn').addClass('hidden');
			
			
			clearTimeout(swatchNavTimer);
			swatchNavTimer = setTimeout(function() {
				$('.gn').removeClass('hidden');
			}, 2500); // 3000 milliseconds = 3 seconds
			
			if($(window).scrollTop() < 100){
				$('html, body').animate({
					scrollTop: $(".gpp").offset().top
				}, 700);
			}
		}
	});
}

function setupProductButtons(){
	$(".scrollToSizing").off().click(function(e) {
      e.preventDefault();
		$('html, body').animate({
			scrollTop: $("#itemSizing").offset().top - 120
		}, 700); // Duration of scroll
	});
	$(".scrollToFeatures").off().click(function(e) {
        e.preventDefault();
		$('html, body').animate({
			scrollTop: $("#gpp-features").offset().top - 120
		}, 700); // Duration of scroll
	});
}




function movePricingOnProductPage(){
	$('.product-main.gp .product-block--price').detach().appendTo('.product-main.gp .product-block--title');
}



function setupGruffBars(includeFreeBeardOil = false){
	//console.log('includeFreeBeardOil', includeFreeBeardOil);
	fetch('/cart.js')
	  .then(response => response.json())
	  .then(cart => {
		$('.gruffbar').html('');
		gruffcart_total = parseFloat(cart.total_price)/100;
		gruffcart_items = cart.items;
		
		//console.log(cart);
		
		var currentTier = 0;
		var toNextTier = 0;
		var currentText = "";
		var nextText = "";
		
		if(includeFreeBeardOil){
			// TIERS FOR FREE BEARD OIL PROMO
			if(gruffcart_total < 0.01){ currentTier = 0; toNextTier = 0.01-gruffcart_total; currentText = ""; nextText = "Free Beard Oil"; }
			if(gruffcart_total >= 0.01){ currentTier = 1; toNextTier = 50-gruffcart_total; currentText = ""; nextText = "Free Shipping"; }
			if(gruffcart_total >= 50){ currentTier = 2; toNextTier = 100-gruffcart_total; currentText = "Free Shipping"; nextText = "1 Free Jockstrap"; }
			if(gruffcart_total >= 100){ currentTier = 3; toNextTier = 150-gruffcart_total; currentText = "1 Free Jock"; nextText = "Free Priority Shipping"; }
			if(gruffcart_total >= 150){ currentTier = 4; toNextTier = 200-gruffcart_total; currentText = "Free Priority Shipping"; nextText = "2 Free Jocks"; }
			if(gruffcart_total >= 200){ currentTier = 5; toNextTier = 300-gruffcart_total; currentText = "2 Free Jocks"; nextText = "3 Free Jocks"; }
			if(gruffcart_total >= 300){ currentTier = 6; currentText = "3 Free Jocks"; }
		}else{
			// TIERS FOR JUST FREE JOCKS PROMO
			if(gruffcart_total < 0.01){ currentTier = 0; toNextTier = 0.01-gruffcart_total; currentText = ""; nextText = "Free Shipping"; }
			if(gruffcart_total >= 0.01){ currentTier = 1; toNextTier = 50-gruffcart_total; currentText = ""; nextText = "Free Shipping"; }
			if(gruffcart_total >= 50){ currentTier = 2; toNextTier = 100-gruffcart_total; currentText = "Free Shipping"; nextText = "1 Free Jockstrap"; }
			if(gruffcart_total >= 100){ currentTier = 3; toNextTier = 150-gruffcart_total; currentText = "1 Free Jock"; nextText = "Free Priority Shipping"; }
			if(gruffcart_total >= 150){ currentTier = 4; toNextTier = 200-gruffcart_total; currentText = "Free Priority Shipping"; nextText = "2 Free Jocks"; }
			if(gruffcart_total >= 200){ currentTier = 5; toNextTier = 300-gruffcart_total; currentText = "2 Free Jocks"; nextText = "3 Free Jocks"; }
			if(gruffcart_total >= 300){ currentTier = 6; currentText = "3 Free Jocks"; }
		}
		var nextTier = currentTier + 1;
		
		var nextTierText = `<div class='nextTier'><b><i class='fa-solid fa-lock'></i></b> Spend <b>` + formatCurrency(toNextTier) + `</b> More to Unlock <b>` + nextText + `</b></div>`;
		if(nextTier == 1){
			var nextTierText;
			if(includeFreeBeardOil){
				nextTierText = `<div class='nextTier'><b><i class='fa-solid fa-lock'></i></b> Add <b>Any Item</b> to Your Cart,<span class='hide-under-500'> </span><br class='hide-over-500'>Then Select Your <b>` + nextText + `</b></div>`;
			}else{
				nextTierText = `<div class='nextTier'><b><i class='fa-solid fa-lock'></i></b> Spend <b>$50</b> for<span class='hide-under-500'> </span><br class='hide-over-500'><b>` + nextText + `</b></div>`;
			}
		}
		
		$('.freeJockSelection, .freeBeardOilSelection').remove();
		
		// Update the progress bar elements
		$('.gruffbar').each(function() {
			$gruffbar = this;
			$(this).addClass('closed');
				if(includeFreeBeardOil){
					// TIERS FOR FREE BEARD OIL PROMO
					$(this).html(`
					<div class='gruffbar_inner'>
						<div class='tierDescriptions'>
							<div class='tier1 desc' data-tier='1'><b><span>Free</span> Beard Oil!</b><i class="fa-solid fa-lock"></i>with Every Order</div>
							<div class='tier2 desc' data-tier='2'><b>Spend <span>$50</span></b><i class="fa-solid fa-lock"></i>Free Shipping</div>
							<div class='tier3 desc' data-tier='3'><b>Spend <span>$100</span></b><i class="fa-solid fa-lock"></i>Free Jock</div>
							<div class='tier4 desc' data-tier='4'><b>Spend <span>$150</span></b><i class="fa-solid fa-lock"></i>Free Priority Shipping</div>
							<div class='tier5 desc' data-tier='5'><b>Spend <span>$200</span></b><i class="fa-solid fa-lock"></i>2 Free Jocks</div>
							<div class='tier6 desc' data-tier='6'><b>Spend <span>$300</span></b><i class="fa-solid fa-lock"></i>3 Free Jocks</div>
						</div>
						<div class='progressBar animated fadeInDown'>
							<div class='bar'>
								<div class='barFilled'></div>
								<div class='barNext'></div>
							</div>
							<div class='tier1 icon circle' data-tier='1'>B</div>
							<div class='tier2 icon' data-tier='2'><i class="fa-solid fa-badge-check"></i></div>
							<div class='tier3 icon circle' data-tier='3'>1</div>
							<div class='tier4 icon circle' data-tier='4'>P</div>
							<div class='tier5 icon circle' data-tier='5'>2</div>
							<div class='tier6 icon circle' data-tier='6'>3</div>
						</div>
						<div class='currentTier'><b><i class='fa-solid fa-lock-open'></i></b> You Unlocked <b>` + currentText + `</b><span class='usaOnly'>(USA Orders Only)</span></div>
						` + nextTierText + `
					</div>
					`);
				}else{
					// TIERS FOR JUST FREE JOCKS PROMO
					$(this).html(`
					<div class='gruffbar_inner'>
						<div class='tierDescriptions'>
							<div class='tier1 desc' data-tier='1'></div>
							<div class='tier2 desc' data-tier='2'><b>Spend <span>$50</span></b><i class="fa-solid fa-lock"></i>Free Shipping</div>
							<div class='tier3 desc' data-tier='3'><b>Spend <span>$100</span></b><i class="fa-solid fa-lock"></i>Free Jock</div>
							<div class='tier4 desc' data-tier='4'><b>Spend <span>$150</span></b><i class="fa-solid fa-lock"></i>Free Priority Shipping</div>
							<div class='tier5 desc' data-tier='5'><b>Spend <span>$200</span></b><i class="fa-solid fa-lock"></i>2 Free Jocks</div>
							<div class='tier6 desc' data-tier='6'><b>Spend <span>$300</span></b><i class="fa-solid fa-lock"></i>3 Free Jocks</div>
						</div>
						<div class='progressBar animated fadeInDown'>
							<div class='bar'>
								<div class='barFilled'></div>
								<div class='barNext'></div>
							</div>
							<div class='tier1 icon' data-tier='1'></div>
							<div class='tier2 icon' data-tier='2'><i class="fa-solid fa-cube" style='text-shadow: 0px 0px 6px black;'></i></div>
							<div class='tier3 icon circle' data-tier='3'>1</div>
							<div class='tier4 icon circle' data-tier='4'>P</div>
							<div class='tier5 icon circle' data-tier='5'>2</div>
							<div class='tier6 icon circle' data-tier='6'>3</div>
						</div>
						<div class='currentTier'><b><i class='fa-solid fa-lock-open'></i></b> You Unlocked <b>` + currentText + `</b><span class='usaOnly'>(USA Orders Only)</span></div>
						` + nextTierText + `
					</div>
					`);
				}
				
				if(gruffcart_total >= 300){
					$('.gruffbar').prepend('<div class="center"><h2>3 Free Jocks Unlocked!</h2></div>');
				  }
				
				if(currentTier == 0){
					$('.currentTier').slideUp(100);
					$('.nextTier').slideDown(100);
					
					if(includeFreeBeardOil){
						// TIERS FOR FREE BEARD OIL PROMO
						$('.gruffbar').prepend(`<div class="center" style="top: 15px;"><h2>Free Jocks & Beard Oil!<span class='usaOnly'>(USA Orders Only)</span></h2><div class="is-flex">
							<div><b>Every Order:</b><br/><span><b>1</b> Free Beard Oil</span></div>
							<div><small>Spend</small> <b>$100:</b><br/><span><b>1</b> Free Jock</span></div>
							<div><b>$200:</b><br/><span><b>2</b> Free Jocks</span></div>
							<div><b>$300:</b><br/><span><b>3</b> Free Jocks!</span></div>
						</div></div>`);
					}
					else{
						// TIERS FOR JUST FREE JOCKS PROMO
						$('.gruffbar').prepend(`<div class="center" style="top: 15px;"><h2>Free Jocks!<span class='usaOnly'>(USA Orders Only)</span></h2><div class="is-flex">
							<div><small>Spend</small> <b>$100:</b><br/><span><b>1</b> Free Jock</span></div>
							<div><b>$200:</b><br/><span><b>2</b> Free Jocks</span></div>
							<div><b>$300:</b><br/><span><b>3</b> Free Jocks!</span></div>
						</div></div>`);
					}
					$('.tier1').addClass('next');
				}
				else if(currentTier == 1 && includeFreeBeardOil == false){
					$('.currentTier').slideUp(100);
				}
				else if(currentTier == 6){
					$('.currentTier').slideDown(100); $('.nextTier').slideUp(100);
				}
				else{
					$('.currentTier, .nextTier').slideDown(100);
				}
				
				
				if(currentTier >= 1 && currentTier <= 5){
					for(var i = 1; i <= currentTier; i++){
						$('.tier' + i).addClass('active');
					}
					$('.tier' + nextTier).addClass('next');
				}
				
				if(currentTier == 6){ $('.tier1,.tier2,.tier3,.tier4,.tier5').addClass('active'); $('.tierDescriptions').hide(); $('.barFilled').css('width','100%');$('.barNext').css('width','100%'); }
				
				if(includeFreeBeardOil){
					setGruffBarsWithBeardOil();
				}else{
					setGruffBars();
				}
				
				$('.desc.active i').removeClass('fa-lock').addClass('fa-lock-open');
				
				$('.progressBar .icon').on('mouseenter click', function() {
					var tier = $(this).data('tier'); // Get the data-tier value
				
					// Fade in the description that matches the data-tier value
					$('.tierDescriptions .desc').filter('[data-tier="' + tier + '"]').css('opacity', '1');
				
					// Fade out the other descriptions
					$('.tierDescriptions .desc').not('[data-tier="' + tier + '"]').css('opacity', '0');
				});
				
				$('.gruffbar').on('mouseleave', function() {
					// Hide all descriptions
					$('.tierDescriptions .desc').css('opacity', '0');
				
					// Show the .desc.next element
					$('.desc.next').css('opacity', '1');
				});
				
				// Check if cart_level_discount_applications exists and is an array
				if (Array.isArray(cart?.cart_level_discount_applications)) {
					cart.cart_level_discount_applications.forEach(function(discountApplication) {
						var couponCode = discountApplication['title'] ?? '';
						var couponDiscount = parseFloat(discountApplication['total_allocated_amount'] ?? 0) / 100;
						
						if (couponCode !== '') {
							$('.gruffbar_inner').append("<div class='couponNotice animated fadeInUp'>Coupon Code <b>" + couponCode + "</b> Applied" + (couponDiscount > 0 ? ".<br>You're Saving <b>" + formatCurrency(couponDiscount) + "!</b>" : "") + "</div>");
	
						}
					});
				}
			if($('.product-block--description').length){
				let text = removeEmojis($('.product-block--description').text());
				let descriptionBlock = $('<div class="description">' + text + '</div>').appendTo('.gruffbar');
				adjustFontSize(descriptionBlock);
			}
		});
		
		if(includeFreeBeardOil){
			var beardOilOwed;
			if(gruffcart_total >= .01){ beardOilOwed = 1; }
			else{ beardOilOwed = 0; }
			
			var beardOilIDValues = Object.values(beardOilIDs);
			
			var beardOilsInCart = 0;
			if (cart && cart.items && Array.isArray(cart.items)) {
				cart.items.forEach(item => {
					if (beardOilIDValues.includes(String(item.id))) {
						beardOilsInCart = beardOilsInCart + (item.quantity ?? 1);
					}
				});
			}else{
				beardOilsInCart = 0;
			}
			var beardOilsRemaining = beardOilOwed - beardOilsInCart;
			if(beardOilsRemaining > 0){$('.cart_content .cartHeader').slideUp();}
			var selectionHTML = '';
			// FOR LOOP: Append free Beard Oil Based on beardOilsRemaining
			for (var i = 0; i < beardOilsRemaining; i++) {
				selectionHTML = selectionHTML + `
					<div class='freeBeardOilSelection gpp-sizing x' data-inc='` + i + `'>
						<h2><i class="fa-solid fa-lock-open"></i> Select Your <b>Free Beard Oil</b> Scent</i></h2>
						<div class='is-flex is-justify-center'>
							<div data-scent="Leather" class='hover-scale-3'><span class="top">Leather</span><span class="bottom">Leatherworker's Shop</span></div>
							<div data-scent="Sugar Cookie" class='hover-scale-3'><span class="top">Sugar Cookie</span><span class="bottom">Sugar & Maple</span></div>
							<div data-scent="Sandalwood" class='hover-scale-3'><span class="top">Sandalwood</span><span class="bottom">Pine & Wood</span></div>
							<div data-scent="Mint & Moss" class='hover-scale-3'><span class="top">Mint & Moss</span><span class="bottom">Minty & Herbal</span></div>
							<div data-scent="Classic" class='hover-scale-3'><span class="top">Classic</span><span class="bottom">Bright Citrus</span></div>
						</div>
					</div>
				`;
				
			}
			if(beardOilsRemaining<0){
				// if somehow more free beard oils are in cart than they are owed
				let beardOilsToRemove = beardOilsRemaining * -1;
				for (var scent in beardOilIDs) {
					if (beardOilIDs.hasOwnProperty(scent)) {
						let field = '.gn ul.cart_items li[data-variant-id="'+beardOilIDs[scent]+'"]';
						if($('body.cart').length){
							field = 'div.cart__item[data-variant-id="'+beardOilIDs[scent]+'"]';
						}
						if($(field).length && beardOilsToRemove > 0){
							$(field).find('a.cart__remove-btn').trigger('click');
							beardOilsToRemove--;
						}
					}
				}
				
			}
			$('.gruffbar').after(selectionHTML);
			$('.gn .cart_content').prepend(selectionHTML);
		} // closing if(includeFreeBeardOil)
		
		var jocksOwed;
		if(gruffcart_total < 100){ jocksOwed = 0; }
		else if(gruffcart_total < 200){ jocksOwed = 1; }
		else if(gruffcart_total < 300){ jocksOwed = 2; }
		else{ jocksOwed = 3; }
		
		
		var jockIDValues = Object.values(jockIDs);
		
		var jocksInCart = 0;
		if (cart && cart.items && Array.isArray(cart.items)) {
			cart.items.forEach(item => {
				if (jockIDValues.includes(String(item.id))) {
					jocksInCart = jocksInCart + (item.quantity ?? 1);
				}
			});
		}else{
			jocksInCart = 0;
		}
		var jocksRemaining = jocksOwed - jocksInCart;
		if(jocksRemaining > 0){$('.cart_content .cartHeader').slideUp();}
		var selectionHTML = '';
		// FOR LOOP: Append free Jock Selections based on jocksRemaining
		for (var i = 0; i < jocksRemaining; i++) {
			var naturalLanguage = '';
			if(jocksRemaining > 1){ if(i == 0){ naturalLanguage = '1st ';}else if(i == 1){naturalLanguage = '2nd ';} else if(i==2){naturalLanguage = '3rd ';} }
			selectionHTML = selectionHTML + `
				<div class='freeJockSelection gpp-sizing x' data-inc='` + i + `'>
					<h2><i class="fa-solid fa-lock-open"></i> Select Your <b>`+naturalLanguage+`Free Jock</b> Size</i></h2>
					<div class='is-flex is-justify-center'>
						<div data-size="S" class='hover-scale-3'><span class="top">S</span><span class="bottom">28 - 30 in</span></div>
						<div data-size="M" class='hover-scale-3'><span class="top">M</span><span class="bottom">31 - 33 in</span></div>
						<div data-size="L" class='hover-scale-3'><span class="top">L</span><span class="bottom">34 - 36 in</span></div>
						<div data-size="XL" class='hover-scale-3'><span class="top">XL</span><span class="bottom">36 - 39 in</span></div>
						<div data-size="XXL" class='hover-scale-3'><span class="top">XXL</span><span class="bottom">39 - 42 in</span></div>
					</div>
				</div>
			`;
			
		}
		if(jocksRemaining<0){
			// if somehow more free jocks are in cart than they are owed
			let jocksToRemove = jocksRemaining * -1;
			for (var size in jockIDs) {
				if (jockIDs.hasOwnProperty(size)) {
					let field = '.gn ul.cart_items li[data-variant-id="'+jockIDs[size]+'"]';
					if($('body.cart').length){
						field = 'div.cart__item[data-variant-id="'+jockIDs[size]+'"]';
					}
					if($(field).length && jocksToRemove > 0){
						$(field).find('a.cart__remove-btn').trigger('click');
						jocksToRemove--;
					}
				}
			}
			
		}
		$('.gruffbar').after(selectionHTML);
		$('.gn .cart_content').prepend(selectionHTML);
		
		
		$('.freeJockSelection div[data-size]').off('click').click(function(event) {
			handleFreeJockClick(this);
		});
		if(includeFreeBeardOil){
			$('.freeBeardOilSelection div[data-scent]').off('click').click(function(event) {
				handleFreeBeardOilClick(this);
			});
		}
	}).catch(error => console.error('Error fetching cart:', error));
}

function setGruffBarsWithBeardOil() {
	var barNextWidth, barFilledWidth, multiplier, amtOverBaseline, high, low;
	// Check the tier and calculate widths.
	if (gruffcart_total >= 300) {
		barFilledWidth = '100%'; // Total is at or above the top tier.
		barNextWidth = '100%';
	} else if (gruffcart_total >= 200) {
		// Calculate percentage for the 80-100% tier.
		high = 300;
		low = 200;
		multiplier = 20 / (high-low);
		amtOverBaseline = gruffcart_total - low;
		barFilledWidth = 80 + (multiplier * amtOverBaseline) + '%';
		barNextWidth = '100%';
	} else if (gruffcart_total >= 150) {
		// Calculate percentage for the 60-80% tier.
		high = 200;
		low = 150;
		multiplier = 20 / (high-low);
		amtOverBaseline = gruffcart_total - low;
		barFilledWidth = 60 + (multiplier * amtOverBaseline) + '%';
		barNextWidth = '80%';
	} else if (gruffcart_total >= 100) {
		// Calculate percentage for the 40-60% tier.
		high = 150;
		low = 100;
		multiplier = 20 / (high-low);
		amtOverBaseline = gruffcart_total - low;
		barFilledWidth = 40 + (multiplier * amtOverBaseline) + '%';
		barNextWidth = '60%';
	} else if (gruffcart_total >= 50) {
		// Calculate percentage for the 20-40% tier.
		high = 100;
		low = 50;
		multiplier = 20 / (high-low);
		amtOverBaseline = gruffcart_total - low;
		barFilledWidth = 20 + (multiplier * amtOverBaseline) + '%';
		barNextWidth = '40%';
	} 
	else if (gruffcart_total >= 0.01) {
		// Calculate percentage for the 0-20% tier.
		high = 50;
		low = 0;
		multiplier = 20 / (high-low);
		amtOverBaseline = gruffcart_total - low;
		barFilledWidth = 0 + (multiplier * amtOverBaseline) + '%';
		barNextWidth = '20%';
	} else {
		// gruffcart_total is less than $50.
		multiplier = 20 / 50;
		barFilledWidth = '0%'; 
		barNextWidth = '0%';
	}

	// Set the calculated widths.
	$('.barNext').css('width', barNextWidth);
	$('.barFilled').css('width', barFilledWidth);
}

function setGruffBars() {
	var barNextWidth, barFilledWidth, multiplier, amtOverBaseline, high, low;
	// Check the tier and calculate widths.
	if (gruffcart_total >= 300) {
		barFilledWidth = '100%'; // Total is at or above the top tier.
		barNextWidth = '100%';
	} else if (gruffcart_total >= 200) {
		// Calculate percentage for the 75-100% tier.
		high = 300;
		low = 200;
		multiplier = 20 / (high-low);
		amtOverBaseline = gruffcart_total - low;
		barFilledWidth = 80 + (multiplier * amtOverBaseline) + '%'; // Correctly maps $100 range to 25% of the progress bar
		barNextWidth = '100%';
	} else if (gruffcart_total >= 150) {
		// Calculate percentage for the 50-75% tier.
		high = 200;
		low = 150;
		multiplier = 20 / (high-low);
		amtOverBaseline = gruffcart_total - low;
		barFilledWidth = 60 + (multiplier * amtOverBaseline) + '%'; // Correctly maps $100 range to 25% of the progress bar
		barNextWidth = '80%';
	} else if (gruffcart_total >= 100) {
		// Calculate percentage for the 25-50% tier.
		high = 150;
		low = 100;
		multiplier = 20 / (high-low);
		amtOverBaseline = gruffcart_total - low;
		barFilledWidth = 40 + (multiplier * amtOverBaseline) + '%'; // Correctly maps $100 range to 25% of the progress bar
		barNextWidth = '60%';
	} else if (gruffcart_total >= 50) {
		// Calculate percentage for the 0-25% tier.
		high = 100;
		low = 50;
		multiplier = 20 / (high-low);
		amtOverBaseline = gruffcart_total - low;
		barFilledWidth = 20 + (multiplier * amtOverBaseline) + '%'; // Correctly maps $100 range to 25% of the progress bar
		barNextWidth = '40%';
	} else {
		// gruffcart_total is less than $50.
		high = 50;
		low = 0;
		multiplier = 20 / (high-low);
		amtOverBaseline = gruffcart_total - low;
		barFilledWidth = 0 + (multiplier * amtOverBaseline) + '%'; // Correctly maps $100 range to 25% of the progress bar
		barNextWidth = '20%';
	}

	// Set the calculated widths.
	$('.barNext').css('width', barNextWidth);
	$('.barFilled').css('width', barFilledWidth);
}


function handleFreeJockClick(el) {

	var selectedSize = $(el).data('size');
	
	//var jockIDValues = Object.values(jockIDs);
	var jockID = jockIDs[selectedSize];
	var parentBox = $(el).closest('.freeJockSelection');
	var parentBoxInc = parentBox.attr('data-inc');
	$('.freeJockSelection[data-inc="' + parentBoxInc + '"] *').slideUp(100);
	$.ajax({
		url: '/cart/add.js',
		dataType: 'json',
		cache: false,
		type: 'post',
		data: {
			quantity: 1,
			id: jockID
		},
		success: function(response) {
			
			$('.freeJockSelection[data-inc="' + parentBoxInc + '"]').css('background-color', '#7ac443').html(`<h2 style='display:none;'><i class="fa-solid fa-face-smile-hearts" style='font-size:40px;margin-bottom:20px;'></i><br>Success!</h2>`);
		
			$('.freeJockSelection[data-inc="' + parentBoxInc + '"]').find('h2').slideDown(100);
			if (window.location.pathname === '/cart') {
				setTimeout(function() { window.location.reload(); }, 1000);
			} else {
				setTimeout(function() { $('.freeJockSelection[data-inc="' + parentBoxInc + '"]').slideUp(500); }, 5000);
			}

			$('.gn ul.cart_items').prepend(`
			<li class="mini-cart__item freeJock">
			  <a>
				<div class="cart_image mini-cart__item-image">
				  <img src="http://gruff-pup.myshopify.com/cdn/shop/files/mysteryItemf3f3f5_400x.jpg?v=1700015638" alt="Free Jockstrap">
				</div>
			  </a>
			  <div class="mini-cart__item-content">
				<div class="mini-cart__item-title">
				  <a>Free Jockstrap - ` + selectedSize + `</a>
				</div>
				<div class="mini-cart__item-price">Free</div>
			  </div>
			</li>`);

			jQuery.getJSON('/cart.js', function(cart) {
				$("#header .cart_count").html(cart.item_count);

				$("#header .cart-container .mini_cart").addClass('bounce');
				setTimeout(function() {
					$("#header .cart-container .mini_cart").removeClass('bounce');
				}, 500);
			});

			
		},
		error: function(response) {
			console.log('AJAX error response:', response);
			$('.freeJockSelection[data-inc="' + parentBoxInc + '"]').find('>*').slideUp(100, function() {
				$('.freeJockSelection[data-inc="' + parentBoxInc + '"]').css('background-color', '#bc272d').html(`<h2 style='display:none;'><i class="fa-solid fa-face-spiral-eyes" style='font-size:40px; margin-bottom:20px;'></i><br>Error!</h2><p style='display:none; text-align:center; font-weight: 500; color: #FFF; padding: 20px; font-size: 18px; margin:0;'>There was an error adding your free jock to cart. Please let us know at sales@gruffpup.com!</p>`);
				$('.freeJockSelection[data-inc="' + parentBoxInc + '"]').find('h2, p').slideDown(100);
			});

		}
	});
}

function handleFreeBeardOilClick(el) {

	var selectedScent = $(el).data('scent');
	
	var beardOilImages = {
	  "Leather": "https://gruffpup.com/cdn/shop/files/GPMediaSearch_91_._500x.jpg",
	  "Classic": "https://gruffpup.com/cdn/shop/files/codeblock_GPMediaSearch_3_._500x.jpg",
	  "Sandalwood": "https://gruffpup.com/cdn/shop/files/GPMediaSearch_92_._500x.jpg",
	  "Mint & Moss": "https://gruffpup.com/cdn/shop/files/GPMediaSearch_90_._500x.jpg",
	  "Sugar Cookie": "https://gruffpup.com/cdn/shop/files/codeblock_GPMediaSearch_4_._500x.jpg"
	};
	
	//var beardOilIDValues = Object.values(beardOilIDs);
	var beardOilID = beardOilIDs[selectedScent];
	var beardOilImage = beardOilImages[selectedScent];
	var parentBox = $(el).closest('.freeBeardOilSelection');
	var parentBoxInc = parentBox.attr('data-inc');
	$('.freeBeardOilSelection[data-inc="' + parentBoxInc + '"] *').slideUp(100);
	$.ajax({
		url: '/cart/add.js',
		dataType: 'json',
		cache: false,
		type: 'post',
		data: {
			quantity: 1,
			id: beardOilID
		},
		success: function(response) {
			
			$('.freeBeardOilSelection[data-inc="' + parentBoxInc + '"]').css('background-color', '#7ac443').html(`<h2 style='display:none;'><i class="fa-solid fa-face-smile-hearts" style='font-size:40px;margin-bottom:20px;'></i><br>Success!</h2>`);
		
			$('.freeBeardOilSelection[data-inc="' + parentBoxInc + '"]').find('h2').slideDown(100);
			if (window.location.pathname === '/cart') {
				setTimeout(function() { window.location.reload(); }, 1000);
			} else {
				setTimeout(function() { $('.freeBeardOilSelection[data-inc="' + parentBoxInc + '"]').slideUp(500); }, 5000);
			}

			$('.gn ul.cart_items').prepend(`
			<li class="mini-cart__item freeBeardOil">
			  <a>
				<div class="cart_image mini-cart__item-image">
				  <img src="` + beardOilImage + `" alt="Free Beard Oil - ` + selectedScent + `">
				</div>
			  </a>
			  <div class="mini-cart__item-content">
				<div class="mini-cart__item-title">
				  <a>Free Beard Oil - ` + selectedScent + `</a>
				</div>
				<div class="mini-cart__item-price">Free</div>
			  </div>
			</li>`);

			jQuery.getJSON('/cart.js', function(cart) {
				$("#header .cart_count").html(cart.item_count);

				$("#header .cart-container .mini_cart").addClass('bounce');
				setTimeout(function() {
					$("#header .cart-container .mini_cart").removeClass('bounce');
				}, 500);
			});

			
		},
		error: function(response) {
			console.log('AJAX error response:', response);
			$('.freeBeardOilSelection[data-inc="' + parentBoxInc + '"]').find('>*').slideUp(100, function() {
				$('.freeBeardOilSelection[data-inc="' + parentBoxInc + '"]').css('background-color', '#bc272d').html(`<h2 style='display:none;'><i class="fa-solid fa-face-spiral-eyes" style='font-size:40px; margin-bottom:20px;'></i><br>Error!</h2><p style='display:none; text-align:center; font-weight: 500; color: #FFF; padding: 20px; font-size: 18px; margin:0;'>There was an error adding your free beard oil to cart. Please let us know at sales@gruffpup.com!</p>`);
				$('.freeBeardOilSelection[data-inc="' + parentBoxInc + '"]').find('h2, p').slideDown(100);
			});

		}
	});
}

function coaleseOptions(){
	if(!$('.product-main.gp').length){ return; }
	
	var optionNum = 1;
	var main;
	$('.product-main.gp .swatch .option_title').each(function(){
		if(optionNum == 1){
			main = $(this);
			main.html("Select Your: &nbsp; <b>" + main.text() + "</b>");
		}
		else{
			$(this).slideUp();
			$('<span> / ' + $(this).text() + '</span>').hide().appendTo(main).fadeIn()
		}
		optionNum++;
	});
	main.addClass('gp');
}

function adjustFontSize($textBlock) {
	
	var $parent = $textBlock.parent();
	var maxTextBlockHeight = $parent.height() - 10; // 10px less than the height of the parent
	var maxIterations=300;
	// Reset font size to a starting value if needed
	$textBlock.css('font-size', '8px'); // Starting font size
	
	// Increase font size until the condition is met
	while ($textBlock.height() < maxTextBlockHeight && maxIterations >= 0) {
		var currentFontSize = window.getComputedStyle($textBlock[0]).fontSize;
		currentFontSize = parseFloat(currentFontSize);
		
		var currentFontSize = parseFloat($textBlock.css('font-size').replace('px',''));
		if (!isNaN(currentFontSize)) {
			$textBlock.css('font-size', (currentFontSize + 1) + 'px');
		} else {
			console.log('Error parsing font size.');
			break;
		}
		maxIterations--;
	}

	
	// Change opacity if it's currently 0
	if ($textBlock.css('opacity') === '0') {
		$textBlock.css('opacity', '1');
	}
}


function formatCurrency(amount, locale = 'en-US', currency = 'USD') {
	if (typeof amount !== 'number' || isNaN(amount)) {
		console.log('formatCurrency(): Basic fallback because amount is not a valid number. Amount: ' + amount);
		return `$${amount}`; // Basic fallback if the amount is not a valid number
	}

	try {
		// Define options for currency formatting
		const options = {
			style: 'currency',
			currency: currency
		};

		return amount.toLocaleString(locale, options);
	} catch (error) {
		console.log('formatCurrency(): Simple fallback because of error in formatting. Amount: ' + amount);
		return `${currency} ${amount.toFixed(2)}`; // Simple fallback format
	}
}


function switchSwatches(customSwatches) {
	var numSwatches = Object.keys(customSwatches).length;
	for (var key in customSwatches) {
		if (customSwatches.hasOwnProperty(key)) {
			var swatchInfo = customSwatches[key];
			if(swatchInfo['Swatch Type'] == 'Color'){
				var colors = swatchInfo["Swatch Value"].split(',');
				var gruffSwatch = '<div class="swatch-wrapper xl">' +
								  '<div class="swatch-circle">' +
								  '<div class="half secondary" style="background-color: #' + colors[1] + '; border-color:#' + colors[0] + '; box-shadow: inset 0px 0px 3.5px 2px #' + colors[0] + '42"></div>' +
								  '<div class="half primary" style="background-color: #' + colors[0] + ';"></div>' +
								  '</div>';
	
				if (swatchInfo.Bubble && swatchInfo.Bubble.trim() !== '') {
					gruffSwatch += '<div class="bubble">' + swatchInfo.Bubble + '</div>';
				}
	
				gruffSwatch += '</div>';
	
				// Append the gruffSwatch HTML to the swatch element with the corresponding data-value
				$(".swatch-element[data-value='" + key + "'] label").removeAttr('style').append(gruffSwatch).closest('.swatch-element').addClass('gp');
			}else{
				// swatch is image
				
			}
		}
	}
	$('.swatch-element.color.swatch-element label').css({'width':'auto','height':'auto'});
	checkSwatchSizesAndAdjust();
}

function loadFontNamed(fontName){
	console.log('loadFontNamed("' + fontName + '") called');
	var fontFamily = fontName.replace(/\s+/g, '+'); // Replace spaces with '+'
	WebFont.load({
		google: {
			families: [fontFamily]
		},
		active: function() {
			
			console.log(fontName + ' has been loaded');
			$('.pc-s > span, .pc-f > span, .pc-h > span').addClass('fontLoaded');
		}
	});
}